const csrfToken = (): string => {
    const csrf = document.querySelector("meta[name='csrf-token']")?.getAttribute('content');
    return csrf ? csrf : '';
};

export default csrfToken();
